import React from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "../../auth/protected-route";
import AppBase from "./AppBase";
import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy";
// import 'bootstrap/dist/css/bootstrap.css';

function App() {
  return (
    <Routes>
      {/* Public route: must stay accessible without login for Facebook app review */}
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="*" element={<ProtectedRoute component={AppBase} />} />
    </Routes>
  );
}

export default App;
